import React from "react";
import QuietHoursWarningDialog from "@/components/compliance/QuietHoursWarningDialog";
import ContactComplianceDialog from "@/components/compliance/ContactComplianceDialog";
import type { OutboundGuard } from "@/hooks/useOutboundGuard";

interface OutboundGuardDialogsProps {
  guard: OutboundGuard;
  actionLabel: string;
}

export default function OutboundGuardDialogs({ guard, actionLabel }: OutboundGuardDialogsProps) {
  return (
    <>
      <QuietHoursWarningDialog
        open={guard.quietHoursError !== null}
        error={guard.quietHoursError}
        actionLabel={actionLabel}
        onProceed={() => void guard.proceedQuietHours()}
        onCancel={guard.cancel}
      />
      <ContactComplianceDialog
        refusal={guard.complianceRefusal}
        actionLabel={actionLabel}
        onChooseCheck={(mode) => void guard.chooseDncCheck(mode)}
        onAcknowledge={(suppressFromNowOn) => void guard.acknowledgeContactWarning(suppressFromNowOn)}
        onCancel={guard.cancel}
      />
    </>
  );
}
